import { onMounted, ref } from 'vue';

/** 根据文档与 window 加载状态估算首屏进度（0~1） */
export function usePageLoadProgress() {
  const loadProgress = ref(0.15);
  const pageLoaded = ref(false);

  function bumpProgress(next) {
    loadProgress.value = Math.max(loadProgress.value, next);
  }

  onMounted(() => {
    const { readyState } = document;

    if (readyState === 'interactive' || readyState === 'complete') {
      bumpProgress(0.65);
    }

    if (readyState === 'complete') {
      pageLoaded.value = true;
      bumpProgress(1);
      return;
    }

    document.addEventListener(
      'DOMContentLoaded',
      () => bumpProgress(0.65),
      { once: true },
    );

    window.addEventListener(
      'load',
      () => {
        pageLoaded.value = true;
        bumpProgress(1);
      },
      { once: true },
    );
  });

  return { loadProgress, pageLoaded };
}
